import React from "react";
import { useSelector } from "react-redux";

const RightPanel = () => {
  // const userAccountInfo = useSelector(
  //   (state) => state?.CommonReducer?.accountInfo
  // );
  const subscriptionaccountInfo = useSelector(
    (state) => state?.CommonReducer?.subscriptionaccountInfo,
  );
  const usageAccountInfo = useSelector(
    (state) => state?.CommonReducer?.usageaccountInfo,
  );
  const usageLeadCount = useSelector(
    (state) => state?.CommonReducer?.usageleadcount,
  );

  return (
    <>
      <div id="rightpanel" className="col-custom-2 executive">
        <div className="card shadow mt-2 mb-2">
          <div className="card-header font-weight-bold">Usage</div>
          <div className="card-body similarblk">
            <div className="similarinnerblk">
              <div className="s-company ml-3">
                <i className=" fs-25  las la-user-alt"></i>
              </div>
              <div className="similar-desc text-align-left">
                <div className="font-weight-bold fs-16">
                  {subscriptionaccountInfo?.employeeDownloadCount}
                </div>
                <div className=" fs-12">Total Contacts</div>
              </div>
            </div>
          </div>
        </div>
        <div className="card shadow mb-2">
          <div className="similarblk">
            <div className="similarinnerblk">
              <div className="s-company ml-3">
                <i className=" fs-25  las la-user-plus"></i>
              </div>
              <div className="similar-desc text-align-left">
                <div className="font-weight-bold fs-16">{usageLeadCount}</div>
                <div className=" fs-12">Leads Created</div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="card shadow mb-2">
          <div className="similarblk">
            <div className="similarinnerblk">
              <div className="s-company ml-3">
                <i className=" fs-25  las la-user-cog"></i>
              </div>
              <div className="similar-desc text-align-left">
                <div className="font-weight-bold fs-16">15</div>
                <div className=" fs-12">Contacts Created Via Automation</div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="card shadow mb-4">
          <div className="similarblk">
            <div className="similarinnerblk">
              <div className="s-company ml-3">
                <i className=" fs-25  las la-envelope"></i>
              </div>
              <div className="similar-desc text-align-left">
                <div className="font-weight-bold fs-16">
                  {usageAccountInfo?.viewEmailCount} /{" "}
                  {subscriptionaccountInfo?.viewEmailCount}
                </div>
                <div className=" fs-12">Remaining Email Credits</div>
              </div>
            </div>
          </div>
        </div>
        <div className="card shadow mb-4">
          <div className="similarblk">
            <div className="similarinnerblk">
              <div className="s-company ml-3">
                <i className=" fs-25  las la-mobile"></i>
              </div>
              <div className="similar-desc text-align-left">
                <div className="font-weight-bold fs-16">
                  {usageAccountInfo?.viewMobileCount} /{" "}
                  {subscriptionaccountInfo?.viewMobileCount}
                </div>
                <div className=" fs-12">Remaining Mobile Credits</div>
              </div>
            </div>
          </div>
        </div>
        <div className="card shadow mb-4">
          <div className="similarblk">
            <div className="similarinnerblk">
              <div className="s-company ml-3">
                <i className=" fs-25  las la-building"></i>
              </div>
              <div className="similar-desc text-align-left">
                <div className="font-weight-bold fs-16">
                  {usageAccountInfo?.downloadcount} /{" "}
                  {subscriptionaccountInfo?.companyDownloadCount}
                </div>
                <div className=" fs-12">Remaining Company Downloads</div>
              </div>
            </div>
          </div>
        </div>
        <div className="card shadow mb-4">
          <div className="similarblk">
            <div className="similarinnerblk">
              <div className="s-company ml-3">
                <i className=" fs-25  las la-user-clock"></i>
              </div>
              <div className="similar-desc text-align-left">
                <div className="font-weight-bold fs-16">
                  {usageAccountInfo?.downloadEmployeeCount} /{" "}
                  {subscriptionaccountInfo?.employeeDownloadCount}
                </div>
                <div className=" fs-12">Remaining Contact Downloads</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RightPanel;
